module.exports = __webpack_public_path__ + "media/images/notificationIcon-841dcaa9.svg";